/**
 * The Violations grid's two STRUCTURAL landing filters, as omnisearch tokens.
 * Structural, not a view preference: they suppress rows that are not part of
 * this customer's compliance picture at all, so even a per-facility "total" that
 * ignores the user's filter has to keep them.
 *
 * Tokens rather than Prisma predicates so what they SELECT stays defined once,
 * in the omnisearch handlers. Imported by `apps/oak`, so: no
 * `encamp-prisma/generated/client` import here.
 */
export type ViolationOmnisearchFilter = readonly [key: string, value: string];

/** The rows a user has NOT marked as a duplicate of another violation. */
export const VIOLATION_NOT_DUPLICATE_FILTER: ViolationOmnisearchFilter = ["duplicate", "false"];

/** Current-owner records only; drops the `SHARED_FRS` rows from a prior owner. */
export const VIOLATION_DIRECT_PROVENANCE_FILTER: ViolationOmnisearchFilter = [
  "provenance",
  "DIRECT",
];

/** Both suppressions — the scope a customer-facing total is counted in. */
export const VIOLATION_STRUCTURAL_FILTERS: readonly ViolationOmnisearchFilter[] = [
  VIOLATION_DIRECT_PROVENANCE_FILTER,
  VIOLATION_NOT_DUPLICATE_FILTER,
];

/** Filter pairs as an omnisearch search string, which is what parses them. */
export function violationFilterSearch(filters: readonly ViolationOmnisearchFilter[]): string {
  return filters.map(([key, value]) => `${key}:${value}`).join(" ");
}
